<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Extension toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddExtentionDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="pa-1 ma-0"
      v-if="feedback"
      :value="true"
      type="warning"
      >
      {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-form  ref="addExtentionForm" lazy-validation>

        <v-container  grid-list-md fluid class="ma-0 pa-3">
          <v-layout row wrap>
            <v-flex xs12 >
              <v-text-field
                label="Naam"
                v-model="newExtention.name"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 >
              <v-text-field
                class="pt-4"
                label="Nummer"
                v-model="newExtention.number"
                :rules="requiredRules"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
          
            <v-flex xs12 sm6 >
              <v-select
                class="pt-4"
                v-model="newExtention.type"
                :items="types"
                label="Type"
                item-text="name"
                item-value="id"
                :rules="requiredRules"
                :item-color="companyPrimaryColor.hex"
                :color="companyPrimaryColor.hex"
                background-color="background"       
                hide-details
                required
                outlined
              ></v-select>
            </v-flex>
            
            <v-flex xs12>
              <v-select
                class="pt-4"
                v-model="newExtention.branch"
                :items="branches"
                label="Locatie"
                item-text="branchName"
                item-value="id"
                :rules="requiredRules"
                :item-color="companyPrimaryColor.hex"
                :color="companyPrimaryColor.hex"
                background-color="background"
                no-data-text="Nog geen locaties toegevoegd."          
                hide-details
                required
                outlined
                append-icon="mdi-close"
                @click:append="setNoBranch()"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>

      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              :color="companySecondaryColor"
              @click="closeAddExtentionDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              v-if="busy == false"
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="companyPrimaryColor"
              @click="addExtention()"
              >
              Extension toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>

  </v-card>
</template>


<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/app";
import platform from 'platform'; 

export default {
  name: "add-extension-form",
  props: {
    activeCompData: Object,
    branches: Array,
    types: Array
  },
  data() {
    return {
      panel: [0],
      newExtention: {
        name: "",
        number: null,
        type: "landLine",
        branch: null,
      },
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      showNewDialog: false,
      feedback: null,
      errors: [],
      busy: false,

    };
  },

  methods: {
    closeAddExtentionDialog() {
      this.$emit("newExtentionDialogChange", false);
      this.feedback = null;
      this.newExtention = {
        name: "",
        number: null,
        type: "landLine",
        branch: null,
      };
    },

    setNoBranch(){
      this.newExtention.branch = null;
    },

    addExtention() {
      if (this.newExtention.number && this.newExtention.type) {
        this.busy = true;
        db.collection("extentions")
          .add({
            compId: this.activeCompData.id,
            name: this.newExtention.name,
            number: this.newExtention.number,
            type: this.newExtention.type,
            branch: this.newExtention.branch,
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                software: String(platform.os),
                browser: platform.name + " " + platform.version, 
                action: "Nieuwe extension toegevoegd: " + this.activeCompData.name,
                extra:
                  "<b>Naam:</b> " +
                  this.newExtention.name +
                  "<br>" +
                  "<b>Nummer:</b> " +
                  this.newExtention.number +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.newExtention.type +
                  "<br>" +
                  "<b>Locatie:</b> " +
                  this.newExtention.branch
              })
              .catch(error => {
                console.error("Error logging new extension: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddExtentionDialog();
            this.busy = false;
            console.log("Extension succesfully added");
          })
          .catch(error => {
            this.busy = false;
            console.error("Error adding extension: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding extension: " + this.activeCompName,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul nummer en type in om een extension toe te voegen.";
      }
    }
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
